export default {
  campaigns: [],
  autocomplete_data : [],
  autocomplete_selected : {},
  countries : [],
  countries_selected : {},
  campaign:[],
  submitted_hours:[],
  selected_campaign : {},
  campaign_status:[],
  user_submitted_hours:[],
  selected_submit_hours:[],
  manager_submitted_hours:[],
  manager_selected_submit_hours:[],
  selected_campaign_and_client:[],
  set_comment_field:[],
  selected_comment_field : [],
  client_dashboard:[]
}
